/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentFinalStanding
 */
export interface TournamentFinalStanding {
    /**
     * 
     * @type {number}
     * @memberof TournamentFinalStanding
     */
    place?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentFinalStanding
     */
    teamId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentFinalStanding
     */
    prizeClaimed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentFinalStanding
     */
    prizeAmount?: number;
}

/**
 * Check if a given object implements the TournamentFinalStanding interface.
 */
export function instanceOfTournamentFinalStanding(value: object): value is TournamentFinalStanding {
    return true;
}

export function TournamentFinalStandingFromJSON(json: any): TournamentFinalStanding {
    return TournamentFinalStandingFromJSONTyped(json, false);
}

export function TournamentFinalStandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentFinalStanding {
    if (json == null) {
        return json;
    }
    return {
        
        'place': json['place'] == null ? undefined : json['place'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'prizeClaimed': json['prizeClaimed'] == null ? undefined : json['prizeClaimed'],
        'prizeAmount': json['prizeAmount'] == null ? undefined : json['prizeAmount'],
    };
}

export function TournamentFinalStandingToJSON(json: any): TournamentFinalStanding {
    return TournamentFinalStandingToJSONTyped(json, false);
}

export function TournamentFinalStandingToJSONTyped(value?: TournamentFinalStanding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': value['place'],
        'teamId': value['teamId'],
        'prizeClaimed': value['prizeClaimed'],
        'prizeAmount': value['prizeAmount'],
    };
}

